module.exports = "/_next/static/images/about-the-product-kit-diputi@2x-min-60d4f8bef717bd7330de8dd075384d15.png.webp";